import { z } from 'zod'
import { oc } from '@orpc/contract'

export const getFutureAppointmentsByPatient = oc
  .route({ method: 'GET', path: '/v2/appointments/future-by-patient' })
  .input(
    z.object({
      patientId: z.string(),
      excludeAppointmentId: z.string().optional(),
    }),
  )
  .output(
    z.object({
      items: z.array(
        z.object({
          appointmentId: z.string(),
          encounterId: z.string().nullable(),
          start: z.string().nullable(),
          end: z.string().nullable(),
          practitionerName: z.string().nullable(),
        }),
      ),
    }),
  )
